import { Card, Layout, Section, Tag, Text } from '@loadsmart/loadsmart-ui'
import { Accordion, AccordionDetails, AccordionSummary, Divider, Drawer } from '@mui/material'
import { LocalIntegrationTestCase } from 'common/types/kraken-core/IntegrationTest'
import FileViewer from 'molecules/FileViewer/FileViewer'
import { useEffect, useState } from 'react'
import IntegrationTestCaseStatus from './IntegrationTestCaseStatus'

export interface IntegrationTestCaseExecutionResultDrawerProps {
  open: boolean
  localTestCase?: LocalIntegrationTestCase
  onClose?: () => void
}

export default function IntegrationTestCaseExecutionResultDrawer(
  props: IntegrationTestCaseExecutionResultDrawerProps
) {
  const testCase = props.localTestCase
  const result = props.localTestCase?.execution.result

  return (
    <Drawer
      open={props.open}
      anchor="right"
      PaperProps={{
        style: {
          width: '60%',
        },
      }}
      onClose={props.onClose}
    >
      {testCase && result ? (
        <Layout.Stack space="none">
          <Layout.Stack className="p-4">
            <Layout.Stack>
              <Text variant="body-bold">{testCase.description}</Text>
              <IntegrationTestCaseStatus test={testCase} />
            </Layout.Stack>
          </Layout.Stack>
          <Divider />

          <Layout.Box className="p-4">
            <Layout.Stack space="s">
              <Text variant="body-bold">Details</Text>
              <Layout.Grid className="w-full p-4 rounded bg-neutral-lighter">
                <pre style={{ whiteSpace: 'break-spaces' }}>{result.details}</pre>
              </Layout.Grid>
            </Layout.Stack>
          </Layout.Box>

          <Layout.Box className="p-4">
            <Card>
              <Card.Title>
                <Layout.Stack space="s">
                  <Text variant="body-bold">Output</Text>
                  <Text>All outputs generated during the test execution</Text>
                </Layout.Stack>
              </Card.Title>
              <Card.Separator />
              <Card.Body>
                <div>
                  <Accordion>
                    <AccordionSummary>
                      <Layout.Group align="center">
                        <Text variant="body-bold">Messages</Text>
                        <Tag variant="accent">{result.generated?.messages.length || 0}</Tag>
                      </Layout.Group>
                    </AccordionSummary>
                    <AccordionDetails>
                      <FileViewer
                        contentType="application/json"
                        content={JSON.stringify(result.generated?.messages, null, 2)}
                        options={{}}
                        showOptions={false}
                      />
                    </AccordionDetails>
                  </Accordion>
                  <Accordion>
                    <AccordionSummary>
                      <Layout.Group align="center">
                        <Text variant="body-bold">Chekcers</Text>
                      </Layout.Group>
                    </AccordionSummary>
                    <AccordionDetails>
                      <FileViewer
                        contentType="application/json"
                        content={JSON.stringify(result.chekers_outcome, null, 2)}
                        options={{}}
                        showOptions={false}
                      />
                    </AccordionDetails>
                  </Accordion>
                </div>
              </Card.Body>
            </Card>
          </Layout.Box>
        </Layout.Stack>
      ) : null}
    </Drawer>
  )
}
